module.exports = __webpack_public_path__ + "media/images/icons/star-74d2b015e70ea9775da91f1408ffe9d2.svg";